import { Anchor, Box, Card, Divider, Paragraph, TextButton } from '@zillow/constellation-10';
import { CIC_SUPPORT_URL } from '@zg-rentals/applications-utils';
import { type EmitMetric, UserType } from '../../models/report-models';
import type React from 'react';

interface BackgroundReportFooterProps {
  userType?: UserType;
  emitMetric: EmitMetric;
}

export function BackgroundReportFooter({ userType, emitMetric }: BackgroundReportFooterProps) {
  return (
    <>
      <Paragraph textStyle="body-xs-bold" css={{ marginTop: 'loose', marginBottom: 'tighter' }}>
        Bureau Contact Information
      </Paragraph>
      <Paragraph textStyle="fineprint" css={{ marginBottom: 'default' }}>
        Contemporary Information Corp.
        <br />
        c/o Consumer Relations Department
        <br />
        3700 Crestwood Parkway, #300
        <br />
        Duluth, GA 30096
        <br />
        Phone: 1-888-316-4242 Fax: 1-888-797-2254
        <br />
        <Anchor href={CIC_SUPPORT_URL} target="_blank">
          www.cicreports.com/consumer-assistance
        </Anchor>
      </Paragraph>
      <Paragraph textStyle="fineprint" css={{ marginBottom: 'default' }}>
        The agency providing this report will provide, when contacted by the consumer seeking a copy of this report or
        making a request to review his/her file with the agency, a written notice in English and Spanish setting forth
        the terms and conditions of his/her right to receive disclosures of information such as office hours, any
        charges for disclosures, identification required for the release of information, names of recipients of reports
        on the consumer, what assistance is available to the consumer in reviewing/understanding the information and
        similar instructions.
      </Paragraph>
      <Box css={{ display: 'flex', justifyContent: 'center' }}>
        <Paragraph textStyle="body-xs">End of Housing Court Record and Criminal Record</Paragraph>
      </Box>
      <Divider css={{ marginTop: 'tighter', marginBottom: 'tighter' }} />
      <Paragraph textStyle="fineprint">
        This report is for rental purposes only. This report is confidential and is not to be disclosed except for
        persons who have legitimate purposes as defined in the Fair Credit Reporting Act and other applicable Federal
        and State regulations.
      </Paragraph>
      {userType === UserType.Renter && (
        <>
          <Card elevated={false} tone="soft" css={{ marginTop: 'loose' }}>
            <Paragraph textStyle="body-sm">
              If any of the information above is incorrect, you may file a dispute with CIC.
            </Paragraph>
            <TextButton
              css={{ marginTop: 'tighter' }}
              onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                e.preventDefault();
                emitMetric('FileADispute BackgroundReport');
                window.open(CIC_SUPPORT_URL, '_blank', 'noopener, noreferrer');
              }}
            >
              File a dispute
            </TextButton>
          </Card>
        </>
      )}
    </>
  );
}
